import React from "react";
import { FaArrowRight, FaLayerGroup, FaPalette, FaMobileScreen, FaGear, FaShieldHalved, FaHeadset } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE, H3_SIZE } from "../home/ui";

const reasons = [
  { icon: FaLayerGroup, title: "Easy Content Management", text: "Update text, images, and pages without coding.", tone: "bg-[#E2F7EA] text-[#16A34A]" },
  { icon: FaPalette, title: "Custom & Modern Design", text: "Unique designs that match your brand identity.", tone: "bg-[#F0E9FF] text-[#7C3AED]" },
  { icon: FaMobileScreen, title: "Responsive & Mobile-Ready", text: "Looks great on all devices.", tone: "bg-[#FFEBDD] text-[#F97316]" },
  { icon: FaGear, title: "SEO Friendly Structure", text: "Optimized for better visibility and rankings.", tone: "bg-[#E3EEFF] text-[#1E5BFF]" },
  { icon: FaShieldHalved, title: "Secure & Reliable", text: "Best security practices and regular updates.", tone: "bg-[#FFE6EF] text-[#E11D74]" },
  { icon: FaHeadset, title: "Dedicated Support", text: "Ongoing assistance even after launch.", tone: "bg-[#EEE8FF] text-[#6D28D9]" },
];

const WhyChooseCms = () => (
  <section className="bg-white py-[40px] lg:py-[56px]">
    <Container className="max-w-[1320px]">
      <div className="grid items-center gap-[32px] rounded-[20px] border-[1px] border-solid border-[#EEF1FA] bg-gradient-to-br from-[#F5F8FF] via-[#F7F8FF] to-[#F6F5FE] p-[24px] sm:p-[32px] lg:grid-cols-[minmax(0,0.78fr)_minmax(0,1.22fr)] lg:gap-[36px] lg:px-[36px] lg:py-[24px]">
        <div>
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#1E5BFF]">Why choose us</p>
          <h2 className={`mt-[10px] font-bold tracking-tight text-[#0B1B4D] ${H2_SIZE}`}>
            <span className="xl:whitespace-nowrap">
              Why Choose Our <span className="text-[#1E5BFF]">CMS</span>
            </span>
            {" "}<br />
            <span className="text-gradient xl:whitespace-nowrap">Website Development?</span>
          </h2>
          <p className="mt-[14px] max-w-[440px] text-[15px] leading-[1.6] text-slate-600 xl:text-[16px]">
            We create CMS websites that are easy to manage, highly customizable and built to your business needs. Focus
            on your business while we handle the technology.
          </p>
          <a
            href="/contact-us"
            className={`group mt-[26px] inline-flex items-center rounded-full bg-gradient-to-r from-[#0E7BFF] via-[#3D5BF6] to-[#A21CF0] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.7)] transition hover:brightness-110 ${BTN_SIZE}`}
          >
            Talk to Our Experts
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>

        <div className="m-swipe grid auto-rows-fr gap-[14px] sm:grid-cols-2 xl:grid-cols-3">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="h-full min-w-0 rounded-[14px] bg-white px-[18px] pb-[18px] pt-[16px] shadow-[0_10px_30px_-18px_rgba(40,60,140,0.28)] transition hover:-translate-y-1"
            >
              <span className={`inline-flex h-[48px] w-[48px] items-center justify-center rounded-full text-[21px] ${r.tone}`}>
                <r.icon />
              </span>
              <h3 className={`mt-[12px] font-semibold text-[#0B1B4D] ${H3_SIZE}`}>{r.title}</h3>
              <p className="mt-[6px] text-[13px] leading-[1.55] text-slate-500 xl:text-[clamp(12px,0.88vw,13.5px)]">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default WhyChooseCms;
